export function isApplePrivateRelayEmail(email?: string): boolean {
  if (!email) {
    return false;
  }

  return (
    email.endsWith('@privaterelay.appleid.com') || email.endsWith('@icloud.com')
  );
}
